module.exports = __webpack_public_path__ + "img/PREOCUPADOS.7b40608c.png";